<div class="page-border">
   <nested-sidemenu></nested-sidemenu>
  <div class="topbarContainer">
    <div class="toptoolbar mainPageMargin">
      <div class="mainLogo">
        <a href="http://www.regione.sardegna.it">
          <img src="assets/ras-bianco-png.svg" alt="Regione Autonoma della Sardegna" class="logo hidden-xs">
          <span class="ras">Regione Autonoma della Sardegna</span>
        </a>
      </div>
      <div *ngIf="authService.isUserAuthenticated()" id="notifyBox">
        <mat-icon class="icon-large" style="position: fixed; top: 3px; left: 50%; width: 28px; height: 25px; ">event</mat-icon>
        <iframe [src]="notifyPollerUrl" frameborder="0" style="position: fixed; top: 0; left: 50%; topheight: 18px; margin-left: -8px;"> </iframe> 
        <div (click)="loadNotificationList($event)"  class="lightbox_trigger" style="background: transparent; position: fixed; top: 0; left: 50%; width: 35px; height: 30px; cursor: pointer;"> </div>
      </div>

      <div class="header-top ">
        <div *ngIf="!authService.isUserAuthenticated()" class="accedi"><a href="{{env.login_url}}">Accedi ai servizi</a></div>      
        <div *ngIf="authService.isUserAuthenticated()" class="accedi"><a href="{{env.logout_url}}">Esci</a></div>      
      </div>
    </div>
    <!-- HEADER -->
    <div class="toolbarContainerDiv mainPageMargin toolbarContainerHeight">
      <div class="hamburger-toggle pull-left"><i class="fa fa-bars"></i><span class="hidden-xs toggle-text">Menu</span></div>      
      <div class="row nomargins">
        <a href="/" title="Home" rel="home" class="toolbartitle toolbartitleHeight">
            <!--
            <strong style="font-weight: bold">Sardegna</strong>SIRA
            <br><span class="toolbarSubtitle">Sistema informativo regionare ambientale</span>
            -->
            <img src="assets/siralogo.png" alt="Regione Autonoma della Sardegna" class="" id="siralogo">
        </a>
      </div>
    </div>
    <!-- MENU -->
    <div class="menubar mainPageMargin">
      <nested-menu>loading</nested-menu>
    </div>
  </div>

  <!-- MAIN CONTENT -->
      <main class="mainContentDiv mainPageMargin">
        <router-outlet></router-outlet>
      </main>



      <div id="backtotop" style="display: block;">Back to top</div>

      <footer class="footer" role="contentinfo">
        <div class="mainPageMargin">
           <div class="row footer-header">
              <div class="col-md-9 footer-title">
                 <h5>Contatti</h5>
                 <div class="row">
                    <div class="col-md-8 footer-block">
                       <div class="footer-element">
                          <div class="views-element-container form-group">
                             <div class="view view-custom-content view-id-custom_content view-display-id-machine_name js-view-dom-id-46dd5880cb304e8341c43dbfc3f20209ee165ab8312e771cc27e80770cc7bbd6">
                                <div class="view-content">
                                   <div class="views-row">
                                      <article role="article" about="/it/node/4" class="custom-content full clearfix">
                                         <div class="content">
                                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                                               <p><strong>Assessorato della difesa dell'ambiente</strong></p>
                                               <p>Via Roma, 80</p>
                                               <p>09100 Cagliari</p>
                                            </div>
                                         </div>
                                      </article>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                    </div>
                    <div class="col-md-4 footer-block">
                       <div class="footer-element">
                          <div class="views-element-container form-group">
                             <div class="view view-custom-content view-id-custom_content view-display-id-machine_name js-view-dom-id-7e8d8ad5d0c48bf25bcd70a7ab7fa4a836969d0b234c1ed3fc22a5f093b2c098">
                                <div class="view-content">
                                   <div class="views-row">
                                      <article role="article" about="/it/node/5" class="custom-content full clearfix">
                                         <div class="content">
                                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                                               <p><strong>Recapiti telefonici</strong></p>
                                               <p>(+39) 070606000</p>
                                            </div>
                                         </div>
                                      </article>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                    </div>
                 </div>
              </div>
              <div class="col-md-3 footer-title">
              </div>
           </div>
           <section id="block-blocco-loghi-istituzionali" class="block block-block-content block-block-contenta61fe895-6b3a-456f-8ef6-679a374a58b8 clearfix">
              <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                 <div class="row footer-header">
                    <div class="col-md-6 col-md-offset-3 footer-block">
                          <img width="100%" src="assets/cbimage.jpg" alt="Regione Autonoma della Sardegna" >
                    </div>
                 </div>
                 <br>
              </div>
           </section>
           <nav role="navigation" aria-labelledby="block-piedipagina-menu" id="block-piedipagina">
            <ul class="menu nav">
               <!--
               <li>
                  <a href="https://portal.sardegnasira.it/glossario_valutazioni_ambientali" title="Glossario" data-drupal-link-system-path="Glossario">Glossario</a>
               </li>
               -->
               <li>
                  <a routerLink="notelegali" title="Vai alla pagina &quot;Note legali&quot;">Note legali</a>
               </li>
               <!--
               <li>
                  <a routerLink="cookies" title="Vai alla pagina &quot;sui cookies&quot;">Cookies</a>
               </li>
               <li>
                  <a routerLink="privacy" title="Vai alla pagina &quot;sulla privacy&quot;">Privacy</a>
               </li>
               -->
               <li>
                  <a routerLink="privacy" title="Vai alla pagina &quot;sulla privacy&quot;">Privacy e Cookie</a>
               </li>
               <li>
                  <a routerLink="helpdesk" title="Vai alla pagina di help-desk">Help-desk</a>
               </li>
               <li>
                  <a routerLink="contattaci">Contattaci</a>
               </li>
            </ul>
         </nav>           
        </div>
     </footer>
     

  <div *ngIf="showNotifyList" id="lightbox">
    <div id="lightbox-content">
        <table width="80%" align="center" style="background-color: white; box-shadow: 0 5px 5px 5px rgba(21, 76, 140, 0.7); background-color: white; border-radius: 5px;">
          <tr>
              <td style="vertical-align: middle; padding-top: 10px"><b style="font-size: 1em; padding-left: 10px;">Notifiche Utente</b></td>
              <td style="vertical-align: middle; width: 70px; padding-top: 10px;">
                  <mat-icon class="icon-large" (click)="hideNotifyList();">close</mat-icon>
                </td>
          </tr>
          <tr>
              <td colspan="2">
                <hr/>
                <iframe frameborder="0" [src]="notifyListUrl" style="width: 100%; height:300px;"></iframe>
                </td>
          </tr>
        </table>
    </div>
  </div>

  <div class="menu-underlayer" id="overlayer"></div>
</div>

